import React, { useCallback, useEffect, useMemo, useState } from "react";
import { get, find, filter } from "lodash";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import { SearchOutlined } from "@ant-design/icons";
import { Badge, IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { Dropdown } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import NoteForm from "features/forms/BubbleNotes";
import MessageRenderer from "components/MessageRenderer";
import { useNotesByBook } from "store/notes/bubbleSelector";
import { lighten } from "polished";
import ResizeAndDragabbleNotes from "./ResizeAndDragabbleNotes";
import { bubbleNoteVisibleForClass, imageFetch, imageFetchFromPodcast, isVideo } from "utils/lib/ebookHelper";
import { useResources } from "store/resources/selectors";
import { useAllBook } from "store/books/selectors";
import ClickOutside from "./OnClickOutside";
import { useFullScreen } from "utils/context/FullScreenProvider";
import { useAlert } from "./UI/alertSakeBar/alertProvider";
import ShareNotesList from "modules/shareNotes/shareNotesList";
import ShareAction from "modules/shareNotes/shareAction";
import { useStory } from "store/story/selectors";
import { useDispatch } from "react-redux";
import { useCurrentClass } from "store/classes/selectors";
import { handleGetShareByWithMeList } from "store/notes/thunks";
import linesSvg from "../utils/assets/images/lines.svg";
import editpencelSvg from "../utils/assets/images/editpencel.svg";
import SentryWrap from 'components/Sentry';

const SearchArea = styled.div`
  border-radius: 20px;
  height: 38px;
  width: 100%;
  display: flex;
  flex-direction: row;
  background: #ddd;
  justify-content: center;
  align-items: center;
`;

const SearchIconArea = styled.div`
  width: 45px;
  height: 38px;
  border-radius: 50% 0% 0% 50%;
  background: #efefef;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SearchInput = styled.input`
  width: 90%;
  height: 30px;
  font-size: 15px;
  background: transparent;
  border: none;
  outline: none;
  margin-left: 5px;
  color: black;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${COLOR.black500};
  }
`;


const ButtonClear = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
`;

const Image = styled.img`
  background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  height: auto;
  width: 33.87%;
  display: flex;
  margin: 0 auto;
  margin-top: 22px;
`;

const NotesText = styled.span`
  color: #2E2E2E;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin-right: 5px;
  margin-top: 3px;
`;

const NoteSec = styled.div`
  background-color: ${(p) => (p.color ? lighten(0.4, `${p.color}`) : "white")};
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  width: 100%;
  margin-top: 20px;
  height: 127px;
  padding: 5px;
  overflow: auto;
`;

const Footer = styled.div`
  position: absolute;
  bottom: 15px;
  left: 0;
  width: 100%;
  background-color: #010a52;
  height: 75px;
  // border-radius: 0% 0% 18px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NotificationDot = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: #ff0000;
  border-radius: 50%;
  border: 2px solid #ffffff;
  z-index: 10;
`;

const DropdownMenu = ({ isStudent, isTeacher, navigate, isAdmin }) => {
  const showAlert = useAlert();
  const handleMenuClick = (event) => {
    event.preventDefault();
    if (isAdmin) {
      showAlert("Please login as teacher!", 'error');
    }
  };
  
  const menu = {
    items: [
      ...(isStudent ? [
        {
          key: 'calendar',
          label: (
            <ButtonClear onClick={() => navigate("calendar")}>
              Calendar
            </ButtonClear>
          )
        },
        {
          key: 'studentData',
          label: (
            <ButtonClear onClick={() => navigate("studentData")}>
              Student Data
            </ButtonClear>
          )
        }
      ] : []),
      ...(isTeacher ? [
        {
          key: 'home',
          label: (
            <ButtonClear onClick={() => navigate("home")}>
              Home
            </ButtonClear>
          )
        },
        {
          key: 'gradebook',
          label: (
            <ButtonClear onClick={() => navigate("gradebook")}>
              Gradebook
            </ButtonClear>
          )
        },
        {
          key: 'classdata',
          label: (
            <ButtonClear onClick={() => navigate("classdata")}>
              Class Data
            </ButtonClear>
          )
        }
      ] : [])
    ],
    style: {
      backgroundColor: '#7978c7',
      border: 'none',
      padding: 0,
    }
  };

  return (
    <SentryWrap>
      {isAdmin ? (
      // <IconButton aria-label="menu" style={{ height: 30, width: 30 }} onClick={handleMenuClick}>
      //   <MenuIcon style={{ fontSize: "24px", color: "#ffffff" }} />
      // </IconButton>
      <img className="menuLinesImg" src={linesSvg} alt="Menu" title="Menu" onClick={handleMenuClick} />
    ) : (
    <Dropdown menu={menu} trigger={["click"]} placement="bottomLeft">
      {/* <IconButton aria-label="menu" style={{ height: 30, width: 30 }}>
        <MenuIcon style={{ fontSize: "24px", color: "#ffffff" }} />
      </IconButton> */}
       <img className="menuLinesImg" src={linesSvg} alt="Menu" title="Menu" />
    </Dropdown>
    )}
    </SentryWrap>
  );
};

const BubbleNotes = ({
  currentUser,
  pageSrc,
  newMaskNote,
  pageNotes,
  page,
  data,
  chapter,
  dataBook,
  BALCON_PAGES=[],
  pageName="",
  storyId=null,
  level=null
}) => {
  const showAlert = useAlert();
  const storyList = useStory();
  const [showDraggable, setShowDraggable] = useState(false);
  const [showAllNotes, setShowAllNotes] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [viewNote, setViewNote] = useState({});
  const [serachText, setSearchText] = useState("");
  const isStudent = currentUser && currentUser.role === "student";
  const isTeacher = currentUser && currentUser?.role === "teacher";
  const isAdmin = currentUser && currentUser?.role === "admin";
  const location = useLocation();
  							  const navigate = useNavigate();
  const seeAllNotes = useNotesByBook();
  const dispatch = useDispatch();
  const currentClass = useCurrentClass();
  const isAssessmentBook = Boolean(dataBook?.isAssessmentBook);
  const notesForCurrentClass = useMemo(() => {
    if (!Array.isArray(seeAllNotes) || !currentClass?.id) return [];
    return seeAllNotes.filter((note) =>
      bubbleNoteVisibleForClass(note, chapter, currentClass.id, isAssessmentBook)
    );
  }, [seeAllNotes, chapter, currentClass?.id, isAssessmentBook]);
  const [listSeeAllNotes, setListSeeAllNotes] = useState(notesForCurrentClass);
  const [isEditing, setIsEditing] = useState(false);
  const [disableDragOnFocus, setDisableDragOnFocus] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [showTeacherNote,setShowTeacherNote] = useState(false);
  const teacher_note = useMemo(() => Array.isArray(notesForCurrentClass) ? notesForCurrentClass.filter(k => k.chapter == chapter && k.page == page && k.userId != currentUser.id) : [], [notesForCurrentClass, chapter, page, currentUser])
  const student_note = useMemo(() => Array.isArray(notesForCurrentClass) ? notesForCurrentClass.filter(k => k.chapter == chapter && k.page == page && k.userId == currentUser.id) : [], [notesForCurrentClass, chapter, page, currentUser])
  const [shareModal, setShareModal] = useState(false);
  const noteOpenedRef = React.useRef(false);
  const [sharedNotes, setSharedNotes] = useState([]);
  
  useEffect(() => {
    setListSeeAllNotes(notesForCurrentClass);
  }, [notesForCurrentClass]);

  useEffect(() => {
    const search = queryString.parse(location.search);
    const noteIdFromUrl = search.noteId;
    
    if (!noteIdFromUrl || noteOpenedRef.current === noteIdFromUrl) {
      if (!noteIdFromUrl) noteOpenedRef.current = false;
      return;
    }
    
    if (!chapter || !page) return;
    
    const matchNote = (note) => {
      const noteIdMatch = String(note.id) === String(noteIdFromUrl);
      const chapterMatch = String(note.chapter) === String(chapter);
      const pageMatch = String(note.page) === String(page);
      return noteIdMatch && chapterMatch && pageMatch;
    };
    
    const openNote = (note) => {
      noteOpenedRef.current = noteIdFromUrl;
      setShowDraggable(true);
      setViewNote(note);
      setShowNote(true);
      setIsEditing(false);
    };
    
    const tryOpenNote = async () => {
      if (Array.isArray(notesForCurrentClass) && notesForCurrentClass.length > 0) {
        const noteToOpen = find(notesForCurrentClass, matchNote);
        if (noteToOpen) {
          openNote(noteToOpen);
          return;
        }
      }
      
      if (currentUser?.id) {
        try {
          const sharedNotesData = await dispatch(handleGetShareByWithMeList({
            bookId: chapter,
            page: page,
            currentUserId: currentUser.id
          }));
          
          const sharedNote = sharedNotesData?.sharedWithMe?.find(matchNote);
          if (sharedNote) {
            setSharedNotes(sharedNotesData.sharedWithMe);
            openNote(sharedNote);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    
    tryOpenNote();
    
    if (!notesForCurrentClass || notesForCurrentClass.length === 0) {
      const timeoutId = setTimeout(tryOpenNote, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [location.search, notesForCurrentClass, chapter, page, navigate, currentUser, currentClass, dispatch]);
  const bookAllList = useAllBook();
  const resources = useResources()
  const modalSrc = useMemo(() => isVideo(chapter, resources) ? imageFetchFromPodcast(chapter, resources) : imageFetch(bookAllList, chapter, viewNote?.page),[viewNote,resources,bookAllList]);
  const { currentFullScreen } = useFullScreen();

  const navigateToStudentDashboard = (to) => {
    switch (to) {
      case "calendar":
        navigate("/student/class?view=assessments");
        break;
      case "studentData":
        navigate("/student/class?view=studentData");
        break;
      default:
        navigate("/student/class?view=home");
        break;
    }
  };

  const navigateToTeacherDashboard = (to) => {
    switch (to) {
      case "home":
        navigate("/admin/class?view=home");
        break;
      case "gradebook":
        navigate("/admin/class?view=gradebook");
        break;
      case "classdata":
        navigate("/admin/class?view=classdata");
        break;
      default:
        navigate("/admin/class?view=home");
        break;
    }
  };
  const handleForDistrictAdmin = () =>{
    if (currentUser.role === 'admin') {
      showAlert('Please login as teacher!' , 'error')
      return true;
    }
    return false;
  }

  const [shareAction, setShareAction] = useState({type: "", open: false});
  const onBubbleNotesClick = ({ key }) => {
    if (handleForDistrictAdmin()) return;
    switch (key) {
      case 'shared_by_me':
        setShareAction({type: "shareByMe", open: true});
        break;
      case 'shared_with_me':
        setShareAction({type: "shareWithMe", open: true});
        break;
      case 'add_note':
        setShowDraggable((prevState) => !prevState);
        setShowNote(false);
        setIsEditing(false);
        break;
      default:
        break;
    }
  };

  const handleSeeAllNotesClick = () => {
    setShowAllNotes(!showAllNotes);
    setShowNote(false);
  };

  const handleBackClick = () => {
    setShowAllNotes(false);
  };

  const onSaveAndClose = () => {
    setShowDraggable(!showDraggable);
    setShowNote(false);
    setIsEditing(false);
    
    const search = queryString.parse(location.search);
    if (search.noteId) {
      const updatedSearch = { ...search };
      delete updatedSearch.noteId;
      const newSearchString = queryString.stringify(updatedSearch);
      const newUrl = location.pathname + (newSearchString ? `?${newSearchString}` : '');
      navigate(newUrl, { replace: true });
    }
  };

  const handleAllNotesClick = (note) => {
    if(note.userId==currentUser.id){
      setViewNote(note);
      setShowAllNotes(false);
      setShowNote(true);
    }else{
      setViewNote(note);
      setShowNote(true);
      setIsEditing(false);
    }
  };

  const searchitems = (txt) => {
    setSearchText(txt);
    if (typeof txt == "string" && txt.length > 0) {
      txt = txt.toLowerCase();
      const fStory = filter(notesForCurrentClass, (st) => {
        const newMaskId = get(
          find(get(data, "content"), (k) => k.pageId == st?.page),
          "numberMasked",
          st?.page
        );
        
        const newMaskIdForBalcon = pageName === "balcon" ? String(getBalconPageNumber(st?.page) || "") : "";
        const newMaskIdForStories = pageName === "stories" ? String(getStoryPageNumber(st?.page) || "") : "";
        const noteTitle = st?.title || "";
        const noteContent = st?.content?.content || st?.content || "";
        
        const balconPageMatch = pageName === "balcon" && newMaskIdForBalcon.toLowerCase().includes(txt);
        const storiesPageMatch = pageName === "stories" && newMaskIdForStories.toLowerCase().includes(txt);
        const regularPageMatch = pageName !== "balcon" && pageName !== "stories" && newMaskId && String(newMaskId).toLowerCase().includes(txt);
        const titleMatch = noteTitle.toLowerCase().includes(txt);
        const contentMatch = noteContent && typeof noteContent === 'string' && noteContent.toLowerCase().includes(txt);
        
        const isMatch = balconPageMatch || storiesPageMatch || regularPageMatch || titleMatch || contentMatch;
        
        return isMatch;
      });
      setListSeeAllNotes(fStory);
    } else {
      setListSeeAllNotes(notesForCurrentClass);
    }
  };

  const primaryRenderNote = student_note?.[0] || pageNotes?.[0];
  const messageRenderData = primaryRenderNote?.content?.content
    ? primaryRenderNote?.content?.content
    : primaryRenderNote?.content;
  const teacherRenderData = teacher_note[0]?.content?.content
    ? teacher_note[0]?.content?.content
    : teacher_note[0]?.content;
  const teacherRenderForColor = teacher_note[0]?.color?.color ? teacher_note[0]?.color?.color : teacher_note[0]?.color
  const studentRenderData = student_note[0]?.content?.content ? student_note[0]?.content?.content : student_note[0]?.content;
  const studentRenderForColor = student_note[0]?.color?.color ? student_note[0]?.color?.color : student_note[0]?.color
  const messageRenderAllData = viewNote?.content?.content
    ? viewNote?.content?.content
    : viewNote?.content;

  const messageRenderForColor = primaryRenderNote?.color?.color ? primaryRenderNote?.color?.color : primaryRenderNote?.color
  const newMaskIdForAll = get(
    find(get(data, "content"), (k) => k.pageId == viewNote?.page),
    "numberMasked",
    viewNote?.page
  );
  const findStoryDetails = useCallback((pageNumber) => {
      const pageNum = parseInt(pageNumber, 10);
      const storyPage = storyList.find((p) => {
        if (!Array.isArray(p.levels)) return false;
        return p.levels.some((level) => {
          const startNum = parseInt(level.start, 10);
          const finishNum = parseInt(level.finish, 10);
          if (isNaN(startNum) || isNaN(finishNum)) return false;
          return startNum <= pageNum && pageNum <= finishNum;
        });
      });
      if (!storyPage) return null;
        const matchingLevel = storyPage.levels.find((level) => {
          const startNum = parseInt(level.start, 10);
          const finishNum = parseInt(level.finish, 10);
          if (isNaN(startNum) || isNaN(finishNum)) return false;
          return startNum <= pageNum && pageNum <= finishNum;
        });

        if (!matchingLevel) return null;
          const startNum = parseInt(matchingLevel.start, 10);
          const relativePage = pageNum - startNum + 1;
          const title = storyPage?.title || "";
          const levelName = matchingLevel?.level || "";
          return { relativePage, title, levelName, pageNum };
   }, [storyList]);

  const getStoryPageNumber = useCallback(
    (pageNumber) => {
      const details = findStoryDetails(pageNumber);
      if (details) return `${details.relativePage} ${details.title} ${details.levelName}`;
      return pageNumber;
    },
    [pageName, storyList],
  );

  const getStoryRelativePageOnly = useCallback((pageNumber) => {
    const details = findStoryDetails(pageNumber);
    if (details) return `${details.relativePage}`;
    return `${pageNumber}`;
  }, [storyList]);

  const getTitleAndLevel = useCallback(
    (pageNumber) => {
      const details = findStoryDetails(pageNumber);
      if (details) return `${details.title} ${details.levelName}`;
      return `${pageNumber}`;
    },
    [storyList],
  );


  const getBalconPageNumber = useCallback((pageNumber) => {
    if (pageName === 'balcon' && BALCON_PAGES?.length > 0) {
      const balconPage = BALCON_PAGES.find(p => {
        const startNum = parseInt(p.start, 10);
        const finishNum = parseInt(p.finish, 10);
        const pageNum = parseInt(pageNumber, 10);
        return startNum <= pageNum && finishNum >= pageNum;
      });
      if (balconPage) {
        const pageNum = parseInt(pageNumber, 10);
        const startNum = parseInt(balconPage.start, 10);
        const pageResult = pageNum - startNum + 1;
        return `${pageResult}`;
      }
    }
    return pageNumber;
  }, [pageName, BALCON_PAGES]);

  const is_other_user_teacher =
    !showTeacherNote &&
    ((showNote ? viewNote?.userId : (student_note?.[0]?.userId ?? currentUser?.id)) === currentUser?.id);
  const [position, setPosition] = useState({
    x: -450, 
    y: 10,
    width: 215,
    height: 255,
  });

  const handleResize = () => {
    
    if(currentFullScreen){
      setPosition((prev) => ({ ...prev, x: -660, y: 50 }));
    }else{
      if (window.innerWidth <= 400) {
            setPosition((prev) => ({ ...prev,y: -250, x: -260 }));
          } else if (window.innerWidth <= 768) {
            setPosition((prev) => ({ ...prev, y: currentFullScreen ? -20 : -250, x: currentFullScreen ? -300 : -240 }));
          } else if (window.innerWidth <= 1024) {
            setPosition((prev) => ({ ...prev, y: currentFullScreen ? -20 : -200, x: -400 }
            ));
          } else {
            setPosition((prev) => ({ ...prev, x: -600 }));
          }
    }
  };

  useEffect(() => {
    handleResize(); // Set initial position based on screen size
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [currentFullScreen]);

  const getShortNameForName = useMemo(() =>{
    const allPageNumber = Array.isArray(seeAllNotes) ? seeAllNotes?.map((item) => item.page) : [];

    const getShortName = allPageNumber.map((item2) => {
      const data = BALCON_PAGES.find((balcon) => {
        const startNum = parseInt(balcon.start, 10);
        const finishNum = parseInt(balcon.finish, 10);
        const pageNum = parseInt(item2, 10);
        return startNum <= pageNum && pageNum <= finishNum;
      });
      return data;
    });
    return getShortName;
},[seeAllNotes,BALCON_PAGES]);

  
  const getShortNameForPage = useCallback((pageNumber) => {
    const data = BALCON_PAGES.find((balcon) => {
      const startNum = parseInt(balcon.start, 10);
      const finishNum = parseInt(balcon.finish, 10);
      const pageNum = parseInt(pageNumber, 10);
      return startNum <= pageNum && pageNum <= finishNum;
    });
    return data?.shortName || "";
  }, [BALCON_PAGES]);

  // Check if there are notes on current page
  const hasNotesOnPage = useMemo(() => {
    const currentPageNotes = Array.isArray(notesForCurrentClass)
      ? notesForCurrentClass.filter(k => String(k.chapter) === String(chapter) && String(k.page) === String(page))
      : [];
    return currentPageNotes.length > 0;
  }, [notesForCurrentClass, chapter, page]);


  const hideShareModal = () => {
    setShareModal(false);
  }

  const menu = [
    {
      key: 'shared_by_me',
      label: 'Shared By Me',

    },
    {
      key: 'shared_with_me',
      label: 'Shared With Me'
    },
    {
      key: 'add_note',
      label: 'Note'
    }
  ]

  const handleShareNoteClick = () => {
    setShareModal(true);
  }

  const currentNoteId = useMemo(() => {
    if (showNote && viewNote?.id) {
      return viewNote;
    }
    if(listSeeAllNotes?.length > 0){
      return listSeeAllNotes?.find((note) => String(note?.chapter) === String(chapter) && String(note?.page) === String(page));
    }
    return {};
  },[listSeeAllNotes, chapter, page, showNote, viewNote])
  
  return (
    <SentryWrap>
    <div className="bubble-notes">
      <ShareNotesList note_id={currentNoteId?.id} shareList={currentNoteId?.share_list || []} shareModal={shareModal} hideShareModal={hideShareModal} />
      <ShareAction 
        from={pageName} 
        action={shareAction?.type} 
        open={shareAction?.open} 
        setOpen={setShareAction} 
        bookId={chapter} 
        pageId={page}
        seeAllNotes={notesForCurrentClass}
        onOpenNotes={() => {
          setShowDraggable((prevState) => !prevState);
          setShowNote(false);
          setIsEditing(false);
        }}
      />
     {currentUser?.role === 'teacher' ? (
         <Dropdown menu={{items: menu, onClick: onBubbleNotesClick }} trigger={["click"]} placement="bottomLeft">
         <div
           className="bubble-note-img"
           style={{ position: 'relative' }}
           >
           {hasNotesOnPage ? (
             <Badge
                 overlap="rectangular"
                 badgeContent={"✓"}
                 color="success"
                 variant="standard"
               >
                 <img src={editpencelSvg} alt="Bubbleimg" title="Bubbleimg" />
               </Badge>
           ) : (
             <img src={editpencelSvg} alt="Bubbleimg" title="Bubbleimg" />
           )}
         </div>
         </Dropdown>

     ): (
      <div
           className="bubble-note-img"
           style={{ position: 'relative' }}
           onClick={() => {
            onBubbleNotesClick({key: 'add_note'});
           }}
           >
           {hasNotesOnPage ? (
             <Badge
                 overlap="rectangular"
                 badgeContent={"✓"}
                 color="success"
                 variant="standard"
               >
                 <img src={editpencelSvg} alt="Bubbleimg" title="Bubbleimg" />
               </Badge>
           ) : (
             <img src={editpencelSvg} alt="Bubbleimg" title="Bubbleimg" />
           )}
         </div>
     )}
   
    

      {showDraggable && (
        <ClickOutside onClickOutside={() => setIsDragging(false)}>
        <ResizeAndDragabbleNotes
          onFocusValue={isDragging || disableDragOnFocus}
          // className="bubbleNotesTopSection"
          defaultValue={position}
          minWidth="var(--min-width)"
          minHeight="var(--min-height)"
          bounds="window"
          enableResizing={false}
          from="notes"
          style={{
            boxShadow:
              "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
            backgroundColor: COLOR.white,
            overflow: "hidden",
          }}
          className={`bubbleNotesTopSection notes-widget ${
            isDragging  ? "NotesMobAndTab" : ""
          } 
          `}
        >
          <div 
            onTouchStart={(event) => {
            event.stopPropagation();
            setIsDragging(true)}}
            className="bubbleNotesHghtSet"
          >
            <div style={{height: '100%', marginBottom: '100px'}}>
            {showNote ?  null : (
               <div  className="bubbleNotesHghtSet">
              {showAllNotes ? (
                <div className="topNotesScection">
                  <SearchArea>
                    <SearchIconArea>
                      <SearchOutlined />
                    </SearchIconArea>
                    <SearchInput
                      type={"text"}
                      value={serachText}
                      placeholder="Search by page"
                      onFocus={(e) => (e.target.placeholder = "")}
                      onBlur={(e) => (e.target.placeholder = "Search by page")}
                      onChange={(e) => {
                        searchitems(e.target.value);
                      }}
                    />
                  </SearchArea>
                </div>
              ) : (
                <div className="pencil-icon-notes-form" style={{ textAlign: "end" }}>

                 {is_other_user_teacher?
                  <IconButton
                    color="primary"
                    style={{ padding: 0 }}
                    onClick={() => {
                      setIsEditing(!isEditing);
                    }}
                    // onTouchStart={() => {
                    //   setIsEditing(!isEditing);
                    // }}
                  >
                    {!isEditing  &&   <Edit className="edit-icon-notes" style={{ fontSize: "30px", color: "#3E5F8F" }} />   }
                    
                  </IconButton>
                  :null}
                  
                </div>
              )}
              {!showNote && (
                <>
                  {isEditing ? (
                    <div>
                      <NoteForm
                        pageNotes={student_note?.[0]}
                        data={student_note?.length > 0 ? student_note : []}
                        page={page}
                        chapter={chapter}
                        close={onSaveAndClose}
                        draggable={(value) => setDisableDragOnFocus(value)}
                        isEditing={isEditing}
                        setIsEditing={setIsEditing}
                        pageNumber={pageName == "balcon" ? getBalconPageNumber(page) || "" : ""}
                        viewNote={viewNote}
                        numberMasked={pageName == "balcon" ? newMaskNote : pageName === "stories" ? getStoryPageNumber(page) : ""}
                        setViewNote={setViewNote}
                        setShowNote={setShowNote}
                        newMaskNote={newMaskNote}
                     />
                    </div>
                  ) : showAllNotes ? (
                    <div>
                      <div className="seeAllAndBackBtn">
                        {/* <button>SEE ALL NOTES</button> */}
                        <button
                          onClick={handleBackClick}
                          // onTouchStart={handleBackClick}
                        >
                          BACK
                        </button>
                      </div>
                      <div className="allBubbleNotesList">
                        {listSeeAllNotes && listSeeAllNotes.length > 0 ? (
                          listSeeAllNotes.map((note, index) => {
                            const newMaskId = get(
                              find(
                                get(data, "content"),
                                (k) => k.pageId == note?.page
                              ),
                              "numberMasked",
                              note?.page
                            );
                            const newMaskIdForBalcon = getBalconPageNumber(note?.page);
                            const newMaskIdForStories = getStoryPageNumber(note?.page);
                            return (
                              <div
                              onClick={() => {
                                handleAllNotesClick(note);
                              }}
                              // onTouchStart={() => {
                              //   handleAllNotesClick(note);
                              // }}
  
                                key={index}
                                className="notsMidTxt notsPageAndTitle"
                              >
                                <label style={{ cursor: "pointer" }}>
                                {pageName == "balcon" ? (
                                  <>
                                    <span>
                                      Page.{pageName == "balcon" ? newMaskIdForBalcon : ""}{" "}
                                      {getShortNameForName[index]?.shortName}
                                    </span>
                                  </>
                                ) : pageName === "stories" ? (
                                  <>
                                    <span>{`Page. ${newMaskIdForStories || ""}`}</span>
                                  </>
                                ) : (
                                  <>
                                    <span>{`Page. ${pageName !== "balcon" ? newMaskId : `${getShortNameForName[index]?.shortName}`}`}</span>
                                  </>
                                )}
                                  <span>
                                    {" "}
                                    {note.title || (pageName === "stories" ? "" : dataBook?.description)} {note.userId!=currentUser.id?"(Teacher)":""}
                                  </span>
                                </label>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bubbleNotesNoData">No Data</div>
                        )}
                      </div>

                    </div>
                  ) : (
                    <>
                      <div className="notesCard">

                       <div className="notesCardLeft"><Image src={pageSrc} alt="" /></div>

                       <div className="notesCardRght">
                        <p>{`Titulo: ${pageName==="balcon" ? getShortNameForPage(page) : pageName === "stories" ? storyList?.find((story) => story.id === storyId)?.title || "" : ""} ${pageName === "stories" ? `${level}` : dataBook?.description || dataBook?.displayName || ""}`}</p>
                        <label>
                          {pageName === "balcon" ? (
                            <>
                              <span className="saved-notes-label">{`Page. ${getBalconPageNumber(page) || ""}`}</span>
                            </>
                          ) : pageName === "stories" ? (
                            <>
                              <span className="saved-notes-label">{`Page. ${getStoryRelativePageOnly(page) || ""}`}</span>
                            </>
                          ) : (
                            <>
                            {newMaskNote !== "" && (
                              <span className="saved-notes-label">{`Page. ${newMaskNote}`}</span>
                            )}
                            </>
                          )}
                          <span className="saved-notes-label"> (Notes will be saved on this page)</span>
                        </label>

                          {pageName !== "videosection" && (
                            <>
                             <button
                            onClick={handleSeeAllNotesClick}
                            onTouchStart={handleSeeAllNotesClick}
                             className="saved-notes-label">
                            SEE ALL NOTES
                          </button>
                          {currentNoteId?.id && currentUser?.role === 'teacher' && (
                          <button onClick={handleShareNoteClick}>Share Notes</button>
                          )}
                            
                            </>
                           
                          )}
                          {pageName === 'videosection' && currentNoteId?.id  && currentUser?.role === 'teacher' && (
                            <button onClick={handleShareNoteClick}>Share Notes</button>
                          )}
                          {teacher_note && teacher_note.length > 0 ? <button
                            onClick={() => { setShowTeacherNote(!showTeacherNote) }}
                            // onTouchStart={() => { setShowTeacherNote(!showTeacherNote) }}
                          >
                            {!showTeacherNote ? "SEE TEACHER NOTES" : "SEE MY NOTES"}
                          </button> : null}

                        </div>

                      </div>
                        
                     
                      <NoteSec color={showTeacherNote ? teacherRenderForColor : isStudent ? studentRenderForColor : messageRenderForColor} className="notesCardMsg notesCardMsgAddOn">
                        <NotesText>Notes:</NotesText>
                        <MessageRenderer
                          style={{ color: "rgb(0 0 0)" }}
                          data={showTeacherNote ? teacherRenderData : isStudent ? studentRenderData : messageRenderData}
                        />
                        <div className="clear"></div>
                      </NoteSec>
                     

                    </>
                  )}
                </>
              )}
            </div>
            )}
           
            {showNote && (
              <>
                {isEditing ? (
                  <div onMouseEnter={()=> setDisableDragOnFocus(true)} onMouseLeave={()=> setDisableDragOnFocus(false)}>
                    <NoteForm
                      setIsEditing={setIsEditing}
                      pageNotes={viewNote}
                      data={[viewNote]}
                      page={viewNote?.page}
                      chapter={viewNote?.chapter}
                      close={onSaveAndClose}
                      draggable={(value) => setDisableDragOnFocus(value)}
                      isEditing={isEditing}
                      pageNumber={pageName == "balcon" ? getBalconPageNumber(viewNote?.page) || "" : pageName === "stories" ? getStoryPageNumber(viewNote?.page) || "" : ""}
                      viewNote={viewNote}
                      numberMasked={pageName === "balcon" ? "" : pageName === "stories" ? getStoryPageNumber(viewNote?.page) : newMaskIdForAll}
                      setViewNote={setViewNote}
                      setShowNote={setShowNote}
                    />
                  </div>
                ) : (
                  <>

                   <div className="pencil-icon-notes-form" style={{ textAlign: "end" }}>
                    {is_other_user_teacher?
                      <IconButton
                        color="primary"
                        style={{ padding: 0 }}
                        onClick={() => {
                          setIsEditing(!isEditing);
                        }}
                        // onTouchStart={() => {
                        //   setIsEditing(!isEditing);
                        // }}
                      >
                        {!isEditing  &&   <Edit className="edit-icon-notes" style={{ fontSize: "30px", color: "#3E5F8F" }} />   } 
                      </IconButton>
                      :null}
                    </div>

                   <div className="notesCard">
 
                    <div className="notesCardLeft"><Image src={ modalSrc} alt="" /></div>

                    <div className="notesCardRght">
                     <p>{`Titulo:  ${pageName==="balcon" ? getShortNameForPage(viewNote?.page) : pageName === "stories" ? `${getTitleAndLevel(viewNote?.page)}`|| "" : ""} ${pageName === "videosection" ? dataBook?.displayName : (pageName === "stories" ? '' :dataBook?.description)}`}</p>
                      <label>
                      {pageName === "balcon" ? (
                        <>
                          <span>{`Page. ${pageName == "balcon" ? getBalconPageNumber(viewNote?.page) : ""}`}</span>
                          
                        </>
                      ) : pageName === "stories" ? (
                        <>
                          <span>{`Page. ${getStoryRelativePageOnly(viewNote?.page) || ""}`}</span>
                        </>
                      ) : (
                        <>
                          <span>{`Page. ${newMaskIdForAll}`}</span>
                        </>
                      )}
                    {viewNote?.userId === currentUser?.id && (
                      <span> (Notes will be saved on this page)</span>
                    )}
                    </label>

                  {viewNote?.userId === currentUser?.id && (
                    <div className="flex items-center">
                        <button
                            onClick={handleSeeAllNotesClick}
                            onTouchStart={handleSeeAllNotesClick}
                          >
                            SEE ALL NOTES
                        </button>
                        {
                          currentUser?.role === 'teacher' && (
                            <button onClick={handleShareNoteClick}>Share Note</button>
                          )
                        }
                    </div>
                  )}
                    </div>
                    
                   </div>

                   <NoteSec color={viewNote?.color?.color} className="notesCardMsg">
                     <NotesText>Notes:</NotesText>
                     <MessageRenderer
                       style={{ color: "rgb(0 0 0)" }}
                       data={messageRenderAllData}
                     />
                   </NoteSec>

                  </>
                )}
              </>
            )}



            {!isEditing && (
              <Footer>
                <button
                  className="notesSaveCloseBtn notesSaveCloseBtnNw"
                  onClick={onSaveAndClose}
                  onTouchStart={onSaveAndClose}
                >
                  Close
                </button>
              </Footer>
            )}
            <div className="widgetFooter" style={{backgroundColor: '#010a52'}}><label>Widget</label></div>
            </div>
            
            
          </div>
          
        </ResizeAndDragabbleNotes>
        </ClickOutside>
      )}

      {(pageName !== "balcon" && pageName !== "stories" && pageName !=="videosection") && (
        <DropdownMenu
        isStudent={isStudent}
        isTeacher={isTeacher}
        isAdmin={isAdmin}
        navigate={
          isTeacher ? navigateToTeacherDashboard : navigateToStudentDashboard
        }
      />
      )}
    
    </div>
    </SentryWrap>
  );
};

export default BubbleNotes;
